module.exports = new __parcel__URL__("kick_8.a6e6cb22.mp3").toString();